module.exports = __webpack_public_path__ + "img/p2-img4-d1-1.ec4fc6d9.png";